"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseManualTasks = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseManualTasks(processData) {
    const manualTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.ManualTask);
    const noManualTasksFound = !((manualTasksRaw === null || manualTasksRaw === void 0 ? void 0 : manualTasksRaw.length) > 0);
    if (noManualTasksFound) {
        return [];
    }
    const manualTasks = manualTasksRaw.map((manualTaskRaw) => {
        const flowNodeId = manualTaskRaw.id;
        try {
            return parseManualTask(manualTaskRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return manualTasks;
}
exports.parseManualTasks = parseManualTasks;
function parseManualTask(manualTaskRaw) {
    const manualTask = (0, ActivityFactory_1.createActivityInstance)(manualTaskRaw, index_1.Model.Activities.ManualTask);
    setRequireConfirmation(manualTask);
    return manualTask;
}
function setRequireConfirmation(manualTask) {
    var _a, _b;
    const requiresConfirmation = (_b = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('requiresConfirmation', manualTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 'true';
    manualTask.requiresConfirmation = requiresConfirmation === 'true';
}
//# sourceMappingURL=ManualTaskParser.js.map